{
  "name": "observation-card-frontend",
  "version": "1.1.0",
  "engines": {
    "node": ">=18.10.0",
    "npm": ">=8.19.2"
  },
  "main": "index.js",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --proxy-config proxy.conf.json",
    "start:staging": "ng server --configuration=staging",
    "start:production": "ng server --configuration=production",
    "build": "ng build",
    "build:staging": "ng build --configuration=staging",
    "build:development": "ng build --configuration=development",
    "build:production": "ng build --configuration=production",
    "watch": "ng build --watch --configuration=development",
    "watch:staging": "ng build --watch --configuration=staging",
    "watch:production": "ng build --watch --configuration=production",
    "test": "ng test",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "prettier": "npx prettier --loglevel warn --check \"src/**/*.html\"",
    "prettier:fix": "npx prettier --loglevel warn --write \"src/**/*.html\"",
    "stylelint": "npx stylelint \"**/*.scss\"",
    "stylelint:fix": "npx stylelint --fix \"**/*.scss\"",
    "lint:fix:all": "npm run lint:fix; npm run stylelint:fix; npm run prettier:fix",
    "prepare": "husky install"
  },
  "keywords": [],
  "author": "",
  "license": "ISC",
  "description": "",
  "dependencies": {
    "@angular/animations": "^18.2.13",
    "@angular/cdk": "^18.2.14",
    "@angular/cli": "^18.2.16",
    "@angular/common": "^18.2.13",
    "@angular/compiler": "^18.2.13",
    "@angular/core": "^18.2.13",
    "@angular/forms": "^18.2.13",
    "@angular/material": "^18.2.14",
    "@angular/material-moment-adapter": "^18.2.14",
    "@angular/platform-browser": "^18.2.13",
    "@angular/platform-browser-dynamic": "^18.2.13",
    "@angular/platform-server": "^18.2.13",
    "@angular/router": "^18.2.13",
    "@automapper/classes": "^8.8.1",
    "@automapper/core": "^8.8.1",
    "@formkit/auto-animate": "^0.8.2",
    "@ng-bootstrap/ng-bootstrap": "^18.0.0",
    "@ng-select/ng-select": "^13.9.1",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@ngxmc/datetime-picker": "^18.2.2",
    "@popperjs/core": "^2.11.8",
    "@types/lodash": "^4.17.16",
    "angular-json-form": "^1.4.6",
    "bootstrap": "^5.3.3",
    "chart.js": "^4.4.8",
    "chartjs-plugin-datalabels": "^2.2.0",
    "file-saver": "^2.0.5",
    "ip": "^2.0.1",
    "material-color-hash": "^0.1.6",
    "moment": "^2.30.1",
    "reflect-metadata": "^0.2.2",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.16",
    "@angular-eslint/builder": "^18.4.3",
    "@angular-eslint/eslint-plugin": "^18.4.3",
    "@angular-eslint/eslint-plugin-template": "^18.4.3",
    "@angular-eslint/schematics": "^18.4.3",
    "@angular-eslint/template-parser": "^18.4.3",
    "@angular/compiler-cli": "^18.2.13",
    "@angular/localize": "^18.2.13",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "^5.1.7",
    "@types/node": "^22.13.16",
    "@typescript-eslint/eslint-plugin": "^8.29.0",
    "@typescript-eslint/parser": "^8.29.0",
    "autoprefixer": "^10.4.21",
    "eslint": "^9.23.0",
    "husky": "^9.1.7",
    "jasmine-core": "^5.6.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "lint-staged": "^15.5.0",
    "postcss": "^8.5.3",
    "prettier": "^3.5.3",
    "stylelint": "^16.17.0",
    "stylelint-config-standard-scss": "^14.0.0",
    "typescript": "~5.4.5"
  },
  "lint-staged": {
    "*.ts": [
      "eslint"
    ],
    "*.html": [
      "prettier --write"
    ],
    "*.scss": "prettier --write"
  },
  "jira-prepare-commit-msg": {
    "messagePattern": "$J $M",
    "jiraTicketPattern": "([A-Z0-9]+-\\d+)",
    "commentChar": "#",
    "isConventionalCommit": false,
    "allowEmptyCommitMessage": false
  }
}
